import React, { useState, useContext, useEffect } from "react";

import { Link, Redirect, withRouter, useLocation } from "react-router-dom";

import PsContext from "../../context";
import { Card, Col, Form, Row, Button } from "react-bootstrap";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import { toast } from "react-hot-toast";
import { Spin } from "antd";
import {
  integerIndMobile,
  lettersOnly,
  lowerCase,
  momentDate,
  upperCase,
  DB_POSTFIX,
  S3_BUCKET_HOME_PATH
} from "../../utils";
import { LOGIN_FOR, LOGIN_FOR_MBA } from "../../utils/data";
import PsModalWindow from "../../utils/PsModalWindow";
import MobileNumberExistAlertMessage from "./mobileNumberExistAlertMessage";

const Registration = (props) => {
  const context = useContext(PsContext);

  let courseType = props.match.params.courseType;

  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [captcha, setCaptcha] = useState([]);
  const [showMobileExitAlert, setShowMobileExistAlert] = useState(false);
  const [toVerify, setToVerify] = useState(false);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const pgtypes = params.get("type");

  useEffect(() => {
    loadCaptcha();
  }, []);

  const loadCaptcha = () => {
    setLoader(true);
    axios.get(ServiceUrl.ADMISSION.CAPTCHA).then((res) => {
      if (res["data"].status == "1") {
        setCaptcha(res["data"]);
      }
      setLoader(false);
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);
    axios
      .post(ServiceUrl.ADMISSION.REGISTER, new FormData(form))
      .then((res) => {
        if (res["data"].status == "1") {
          setToVerify(res["data"].token);
        } else {
          if (
            upperCase(res["data"].message) ==
            upperCase("Mobile number already exist")
          )
            setShowMobileExistAlert(true);
          else toast.error(res["data"].message || "Error");

          loadCaptcha();
        }
        setLoader(false);
      });
  };

  const maxDate = (type) => {
    if (type == "UG") {
      let y = momentDate(new Date(), "YYYY") - 15;
      let d = momentDate(new Date(), "DD");
      let m = momentDate(new Date(), "MM");
      return momentDate(y + "-" + m + "-" + d, "YYYY-MM-DD");
    } else {
      let y = momentDate(new Date(), "YYYY") - 15;
      let d = momentDate(new Date(), "DD");
      let m = momentDate(new Date(), "MM");
      return momentDate(y + "-" + m + "-" + d, "YYYY-MM-DD");
    }
  };
  const applyForValue = () => {
    try {
      let courseType = props.match.params.courseType;
      let loginFor = S3_BUCKET_HOME_PATH == "xiba/" ? LOGIN_FOR_MBA : LOGIN_FOR;
      let s = loginFor.find((item) => item.value == lowerCase(courseType)); 
      if (context.settingValue(s.key) == "1") return upperCase(s.value);

      return "";
    } catch (e) {
      return "";
    }
  };

  if (!courseType) return <></>;
  if (toVerify) {
    let pgtype = "";
    if (pgtypes) {
      pgtype = "&type=" + pgtypes;
    }
    return <Redirect to={`/mobile-verification?token=${toVerify}` + pgtype} />;
  }

  return (
    <>
      <div className="container mb-5 py-4">
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <Card className="rounded-4 border-0 shadow-lg overflow-hidden card-registration">
              <div className="bg-main-theme" style={{ height: "4px" }}></div>
              <Card.Body className="p-4 p-md-5">
                <div className="text-center mb-4">
                  <h4 className="fw-800 text-dark mb-1 font-outfit text-uppercase">
                    Create Account
                  </h4>
                  <p className="text-muted fs-13">Join our academic community today</p>
                </div>

                <Spin spinning={loader}>
                  <Form
                    action=""
                    method="post"
                    noValidate
                    validated={validated}
                    onSubmit={handleFormSubmit}
                  >
                    <input
                      type="hidden"
                      name="academic_year"
                      value={context.settingValue("current_academic_year")}
                    />
                    <input
                      type="hidden"
                      name="i__captchaCode"
                      value={captcha.code}
                    />

                    <Form.Group className="mb-4">
                      <Form.Label className="fs-12 fw-700 text-dark mb-1">
                        Apply For <span className="text-danger">*</span>
                      </Form.Label>
                      {DB_POSTFIX == "drsacpe" && applyForValue() == "PG" ? (
                        <>
                          <input
                            type="hidden"
                            name="i__applyFor"
                            value={applyForValue()}
                          />
                          <Form.Control
                            as="select"
                            name="type"
                            className="form-select custom-floating-input bg-light border-0 no-bg-focus rounded-2"
                            required
                          >
                            <option value="">-Select-</option>
                            <option value="bped">
                              {applyForValue() + " - B.P.Ed"}
                            </option>
                            <option value="mped">
                              {applyForValue() + " - M.P.Ed"}
                            </option>
                          </Form.Control>
                        </>
                      ) : (
                        <div className="custom-floating-wrap">
                           <input
                            type="hidden"
                            name="i__applyFor"
                            value={applyForValue()}
                          />
                          <Form.Control
                            type="text"
                            className="bg-light border-0 custom-floating-input w-100 no-bg-focus rounded-2 fw-700 text-primary"
                            value={S3_BUCKET_HOME_PATH == "xiba/" ? "MBA" : applyForValue()}
                            readOnly
                            required
                          />
                          <label className="custom-floating-label">Category</label>
                        </div>
                      )}
                    </Form.Group>

                    <Row className="g-3 mb-4">
                      <Col md={3}>
                        <div className="custom-floating-wrap">
                          <Form.Control
                            type="text"
                            name="i__initial"
                            placeholder=" "
                            className="bg-light border-0 custom-floating-input w-100 no-bg-focus rounded-2 text-uppercase fw-600"
                            onKeyPress={lettersOnly}
                          />
                          <label className="custom-floating-label">Initial</label>
                        </div>
                      </Col>
                      <Col md={9}>
                        <div className="custom-floating-wrap">
                          <Form.Control
                            type="text"
                            name="i__name"
                            placeholder=" "
                            className="bg-light border-0 custom-floating-input w-100 no-bg-focus rounded-2 text-uppercase fw-600"
                            onKeyPress={lettersOnly}
                            required
                          />
                          <label className="custom-floating-label">Candidate Full Name</label>
                          <Form.Control.Feedback type="invalid">
                            Candidate name is required
                          </Form.Control.Feedback>
                        </div>
                      </Col>
                    </Row>

                    <Form.Group className="mb-4">
                      <div className="custom-floating-wrap">
                        <Form.Control
                          type="number"
                          name="i__mobile"
                          placeholder=" "
                          className="bg-light border-0 custom-floating-input w-100 no-bg-focus rounded-2 fw-600"
                          onKeyPress={integerIndMobile}
                          onWheel={(e) => e.target.blur()}
                          required
                        />
                        <label className="custom-floating-label">Mobile Number</label>
                        <Form.Control.Feedback type="invalid">
                          Mobile number is required
                        </Form.Control.Feedback>
                      </div>
                      <small className="text-primary fw-600 fs-11 mt-1 d-block">
                        <i className="fa-solid fa-circle-info me-1"></i>
                        Preference Aadhaar Linked Mobile Number
                      </small>
                    </Form.Group>

                    <Form.Group className="mb-4">
                      <div className="custom-floating-wrap">
                        <Form.Control
                          type="email"
                          name="i__email"
                          placeholder=" "
                          className="bg-light border-0 custom-floating-input w-100 no-bg-focus rounded-2 fw-600"
                          required
                        />
                        <label className="custom-floating-label">Email Address</label>
                        <Form.Control.Feedback type="invalid">
                          Valid email id is required
                        </Form.Control.Feedback>
                      </div>
                    </Form.Group>

                    <Form.Group className="mb-4">
                      <div className="custom-floating-wrap">
                        <Form.Control
                          type="date"
                          name="i__dob"
                          placeholder=" "
                          className="bg-light border-0 custom-floating-input w-100 no-bg-focus rounded-2 fw-600"
                          max={maxDate(applyForValue())}
                          min={
                            pgtypes
                              ? ""
                              : applyForValue() == "UG"
                              ? "2002-06-01"
                              : "1960-06-01"
                          }
                          required
                        />
                        <label className="custom-floating-label">Date of Birth</label>
                        <Form.Control.Feedback type="invalid">
                          Date of birth is required
                        </Form.Control.Feedback>
                      </div>
                    </Form.Group>

                    <div className="p-3 bg-light rounded-3 mb-4 border border-opacity-10">
                      <Row className="align-items-center g-3">
                        <Col xs={7}>
                          <div className="d-flex align-items-center">
                            <img
                              src={captcha && captcha.img}
                              className="img-fluid border rounded-1 bg-white shadow-sm"
                              alt="captcha"
                              style={{ maxHeight: "32px" }}
                            />
                            <Button
                              type="button"
                              className="ms-3 border-0 bg-transparent text-main-theme p-0 hvr-icon-spin"
                              onClick={(e) => loadCaptcha()}
                            >
                              <i className="fa-solid fa-sync fs-16 hvr-icon"></i>
                            </Button>
                          </div>
                        </Col>
                        <Col xs={5}>
                          <div className="custom-floating-wrap">
                            <Form.Control
                              type="text"
                              name="i__captcha"
                              required
                              placeholder=" "
                              className="border-0 border-bottom border-secondary border-opacity-25 rounded-0 bg-transparent text-center custom-floating-input w-100 no-bg-focus fw-700"
                              style={{ height: "40px", padding: "18px 4px 2px 4px" }}
                              autoComplete="off"
                            />
                            <label className="custom-floating-label w-100 text-center" style={{left:0}}>Security Code</label>
                          </div>
                        </Col>
                      </Row>
                    </div>

                    <div className="mt-4 pt-2">
                      <Button
                        type="submit"
                        className="w-100 btn-main-theme-solid border-0 py-3 fs-15 fw-800 shadow-sm rounded-3 transition-all"
                      >
                        REGISTER NOW
                        <i className="fa-solid fa-arrow-right ms-2"></i>
                      </Button>
                    </div>

                    <div className="text-center mt-4 pt-2 fs-13 text-muted fw-600">
                      Already have an account?{" "}
                      <Link
                        to="/sign-in"
                        className="text-main-theme text-decoration-none border-bottom border-main-theme border-opacity-25 pb-1 hvr-underline"
                      >
                        Sign In Here
                      </Link>
                    </div>
                  </Form>
                </Spin>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      <PsModalWindow
        show={showMobileExitAlert}
        onHide={(e) => setShowMobileExistAlert(false)}
        size="md"
        title="Mobile number exist"
      >
        <MobileNumberExistAlertMessage />
      </PsModalWindow>
    </>
  );
};

export default withRouter(Registration);
